import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import Button from '../../../form/Button';
import './view-toggle.css';

const ViewToggle = ({ toggleView, className, activeToggle }) => {
	const listClass = cs(
		"view-toggle__btn",
		{"view-toggle__btn--active": (activeToggle === "list")}
	)
	const gridClass = cs(
		"view-toggle__btn",
		{"view-toggle__btn--active": (activeToggle === "grid")}
	)

	return (
		<div className={`view-toggle ${className}`}>
			<span className="view-toggle__title">View</span>
			<Button onClick={() => toggleView('list')} className={listClass} color="icon">
				<span className="material-icons">menu</span>
			</Button>
			<Button onClick={() => toggleView('grid')} className={gridClass}  color="icon">
				<span className="material-icons">apps</span>
			</Button>
		</div>
	);
};

ViewToggle.propTypes = {
	className: PropTypes.string,
	toggleView: PropTypes.func.isRequired,
	activeToggle: PropTypes.string.isRequired,
}

export default ViewToggle;


// WEBPACK FOOTER //
// ./src/components/common/files/filters/ViewToggle/index.js